﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import { DisplayValue } from '../Shared/Scripts/Models/Valg';
import SelectOptionStegDisplay from '../Shared/Scripts/Components/SelectOptionStegComponent';
import VelgUniversitetComponent from '../Shared/Scripts/Components/VelgUniversitetComponent';

import VeilederLutDto from './Models/VeilederLutDto';
import { LandViewModel, LutData } from './Utilities/LutApi';
import { VeilederLutAppState } from './Store';
import * as ValgTypes from './Store/Valg/Types';
import { ResultatValg } from './Store/Resultat/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import * as Ids from './Ids';
import VerdensdelValg from './Utilities/A-VerdensdelValg';
import HelsefagValg from './Utilities/D-HelsefagValg';
import ModalKlikkContainer from './Components/ModalKlikkComponent';
import ResultatAComponent, { Larested } from './Components/ResultatAComponent';
import ResultatBComponent from './Components/ResultatBComponent';
import EkstraboksComponent from './Components/EkstraboksContainer';
import { epiResolveLanguage } from '../Shared/Scripts/Utilities/EpiResolveLanguage';

interface AppOwnProps { }

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederLutDto>();

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

interface AppState {
}

const currentLanguage = epiResolveLanguage()

class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
        };
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, epiContext, lutData: nullableLutData, resultat } = this.props;
        const lutData = nullableLutData as LutData; // FIX SUGGESTION: We assume that nullable LutData property is never null
        const { epiModel } = this.props.epiContext;

        // Målet er å sortere LandListe basert på Navn til Land på språket som brukeren har valgt
        // Dette er gjort ved .find og .sort og .localeCompare
        const sortLandListe = (a: LandViewModel, b: LandViewModel): number =>
          // Fin navn til a på riktig språk
          a.Sprakvarianter
            .find(s => s.SprakKode === currentLanguage)?.Navn
            // Sammenlign med b sitt navn
            ?.localeCompare(
              b.Sprakvarianter.find(s => s.SprakKode === currentLanguage)?.Navn
              ?? ""
            ) ?? 0;

        function getLand(): DisplayValue[] {
            const items: DisplayValue[] = [];
            const lutModel: LutData = lutData;

            lutModel.Verdensdeler.forEach(v => {
                if (v.VerdensdelKode === valg.aVerdensdel?.id) {
                    if (v.LandListe !== undefined) {
                        v.LandListe
                          ?.sort(sortLandListe)
                          .forEach(l => {
                            items.push({ id: l.LandKode, displayValue: l.Sprakvarianter.find(s => s.SprakKode === currentLanguage)?.Navn ?? "" });
                        });
                    }
                }
            });

            return items;
        }

        function getLandMerknad(): string {
            const lutModel: LutData = lutData;
            let landMerknad: string = "";

            lutModel.Verdensdeler.forEach(v => {
                if (v.VerdensdelKode === valg.aVerdensdel?.id) {
                    v.LandListe
                    ?.sort(sortLandListe)
                    .forEach(l => {
                        if (v.LandListe !== undefined) {
                            if (valg.bLand?.id === l.LandKode) {
                                landMerknad = l.Sprakvarianter.find(s => s.SprakKode === currentLanguage)?.Kundeveiledning ?? "";
                            }
                        }
                    });
                }
            });

            return landMerknad;
        }

        function getLarested(): Larested | null {
            let larested: Larested | null = null;
            const lutModel: LutData = lutData;

            lutModel.Verdensdeler.forEach(v => {
                if (v.VerdensdelKode === valg.aVerdensdel?.id) {
                    v.LandListe
                    ?.sort(sortLandListe)
                    .forEach(l => {
                        if (v.LandListe !== undefined) {
                            if (valg.bLand?.id === l.LandKode && l.Laresteder !== undefined) {
                                l.Laresteder.forEach(la => {
                                    if (valg.cLarested?.id === la.LarestedId.toString()) {
                                        larested = {
                                            LarestedKundeveiledningstekst: la.Sprakvarianter.find(s => s.SprakKode === currentLanguage)?.Kundeveiledning ?? la.Sprakvarianter[0].Kundeveiledning ?? "",
                                            UtdanningListe: la.UtdanningsoppleggListe,
                                            LarestedWebAdresse: la.LarestedWebAdresse
                                        };
                                    }
                                });
                            }
                        }
                    });
                }
            });

            return larested;
        }

        function getLaresteder(): DisplayValue[] {
            const items: DisplayValue[] = [];
            const lutModel: LutData = lutData;

            lutModel.Verdensdeler.forEach(v => {
                if (v.VerdensdelKode === valg.aVerdensdel?.id) {
                    v.LandListe
                    ?.sort(sortLandListe)
                    .forEach(l => {
                        if (v.LandListe !== undefined && valg.bLand?.id === l.LandKode && l.Laresteder !== undefined) {
                            l.Laresteder.forEach(la => {
                                items.push({ id: la.LarestedId.toString(), displayValue: la.Sprakvarianter.find(s => s.SprakKode === currentLanguage)?.Navn ?? la.Sprakvarianter[0].Navn ?? "" })
                            });
                        }
                    });
                }
            });

            return items;
        }

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null && lutData !== null) {
            const modalKlikkRad: JSX.Element = (
                <ModalKlikkContainer
                    valg={valg}
                    lenketekst={contentResolver(epiContext, 'lenketekstModalVerdensdel')}
                    overskrift={contentResolver(epiContext, 'modalDatabasenTittel')}
                    content={contentResolver(epiContext, 'modalDatabasenContent')}
                    ariaLabel={resolveRawText(epiContext, 'modalDatabasenAriaLabel')}
                />
            );

            return (
                <div className="c-veileder">
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelVerdensdel')}
                        forklaring={<p>{contentResolver(epiContext, 'infoVerdensdel')}</p>}
                        sporsmal="ledetekstVerdensdel"
                        valg={VerdensdelValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aVerdensdel: nyttValg });
                        }}
                        neverCollapse={true}
                        classModifier="c-veileder__panel--input-white"
                        value={valg.aVerdensdel}
                        customBottomRow={modalKlikkRad}
                    />
                    {resultat.visBoksB
                        && (
                            <SelectOptionStegDisplay
                                sporsmalId={Ids.BoksB}
                                tittel={contentResolver(epiContext, 'tittelLand')}
                                options={getLand()}
                                forklaring={contentResolver(epiContext, 'infoLand')}
                                ledetekst={contentResolver(epiContext, 'ledetekstLand')}
                                onSelectChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({
                                        bLand: nyttValg,
                                        dHelsefag: undefined,
                                        eEkstraboks: false,
                                    });
                                }}
                                value={valg.bLand}
                                showSearch={true}
                            />
                        )}
                    {resultat.visBoksC
                        && (
                            <VelgUniversitetComponent
                                sporsmalId={Ids.BoksC}
                                tittel={contentResolver(epiContext, 'tittelLarested')}
                                forklaring={contentResolver(epiContext, 'infoLarested')}
                                ledetekst={contentResolver(epiContext, 'ledetekstLarested')}
                                ingenValgTekst={resolveRawText(epiContext, 'ingenValgtTekstLarested')}
                                options={getLaresteder()}
                                avhukingBoksTekst={contentResolver(epiContext, 'avhukingTekstLarested')}
                                onSelectChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({
                                        cLarested: nyttValg,
                                        dHelsefag: undefined,
                                        eEkstraboks: false,
                                    });
                                }}
                                value={valg.cLarested}
                                showSearch={true}
                            />
                        )}
                    {resultat.visBoksD
                        && (
                            <RadioButtonsStegComponent
                                sporsmalId={Ids.BoksD}
                                tittel={contentResolver(epiContext, 'tittelHelsefag')}
                                forklaring={contentResolver(epiContext, 'infoHelsefag')}
                                sporsmal='ledetekstHelsefag'
                                valg={HelsefagValg.dValg}
                                onInputChange={(nyttValg: Valg<string>): void => {
                                    dispatchUpdateValg({ dHelsefag: nyttValg });
                                }}
                                value={valg.dHelsefag}
                            />
                        )}
                    {resultat.visResultatA
                        && getLarested() && ( // FIX SUGGESTION - validate on  getLarested function call that it returns a value
                            <ResultatAComponent
                                visEkstraboksHandler={(visE: boolean): void => {
                                    dispatchUpdateValg({ eEkstraboks: visE });
                                }}
                                helsefagValg={valg.dHelsefag}
                                landMerknad={getLandMerknad()}
                                larested={getLarested()!} // FIX SUGGESTION: Force return type 
                            />
                        )}
                    {resultat.visResultatB
                        && (
                            <ResultatBComponent />
                        )}
                    {resultat.visEkstraboks
                        && getLarested() && ( // FIX SUGGESTION - validate on getLarested function call that it returns a value
                            <EkstraboksComponent
                                larested={getLarested()!} // FIX SUGGESTION: Force return type
                            />
                        )}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederLutDto>;
    resultat: ResultatValg;
    lutData: LutData | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederLutAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederLutAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    lutData: state.lutData,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
